import { useFormikContext } from 'formik'
import React, { useContext, useEffect } from 'react'
import GenerateFormHTMLNoValid from 'src/app/modules/component/generate-form/GenerateFormHTMLNoValid'
import { CODE_GENERATE_FORM } from 'src/app/modules/utils/Constant'
import { PhanHeTiepDonContext } from '../../../contexts/PhanHeTiepDonContext'
import CustomComponent from '../../../tabs/tab-xu-tri/component-generate/CustomComponent'
import useFormio from 'src/app/hook/useFormio'
import { generateInitValues, generateValidationSchema } from 'src/app/modules/utils/AppFunction'
import { localStorageItem } from 'src/app/modules/utils/LocalStorage'
import { KEY_LOCALSTORAGE } from 'src/app/modules/auth/core/_consts'
import { formatDateDTO } from 'src/app/modules/utils/FormatUtils'

type Props = {
    patientInfo?: any;
	setValidationSchema: (schema: any) => void;
}

const ThongTinChuyenTuyen = ({ patientInfo, setValidationSchema }: Props) => {
    const { values, setFieldValue, errors, touched } = useFormikContext<any>();
    const { benhNhanInfo } = useContext(PhanHeTiepDonContext);
	const currentUser = localStorageItem.get(KEY_LOCALSTORAGE.CURRENT_USER);

	const { formJSON } = useFormio({
		code: CODE_GENERATE_FORM.xuTriThongTinChuyenTuyen,
	});

	useEffect(() => {
		setFieldValue(CODE_GENERATE_FORM.xuTriThongTinChuyenTuyen, {
			...generateInitValues(formJSON),
			...values[CODE_GENERATE_FORM.xuTriThongTinChuyenTuyen],
			htPerson: currentUser?.name,
			htInNetwork: "true",
			htTime: formatDateDTO(new Date()),
		});
		setValidationSchema(generateValidationSchema(formJSON, CODE_GENERATE_FORM.xuTriThongTinChuyenTuyen));
	}, [formJSON]);

    return (
		<div className="spaces pt-10 pl-5 pr-5 h-calc-vh-250 overflow-auto">
			<GenerateFormHTMLNoValid
				listFieldAuto={formJSON}
				values={values}
				setFieldValue={setFieldValue}
				errors={errors}
				touched={touched}
				modelID={CODE_GENERATE_FORM.xuTriThongTinChuyenTuyen}
				customComponent={CustomComponent}
				customProps={{
					visitId: benhNhanInfo?.thongTinKhamBenh?.visit?.id || patientInfo?.visitId
				}}
			/>
		</div>
	);
}

export default ThongTinChuyenTuyen